import { Input } from '@web/components/atoms/Input'
import { Button } from '../../atoms/Button'
import { BiUpload } from '../../atoms/Icons'
import React, { DOMAttributes, ReactElement } from 'react'

interface FilePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  label: string
  acceptedFileTypes: string
  inputRef: React.MutableRefObject<HTMLInputElement | null>
  isLoading?: boolean
  cta?: ReactElement<DOMAttributes<HTMLButtonElement>>
  buttonBgColor?: string
}

export const IMAGE_TYPES =
  '.jpg, .jpeg, .png, .gif, .svg, .webp, .tif, .tiff, .bmp, .heif, .heic, .raw, .cr2, .nef, .arw, .pdf, image/*'

const FilePicker = (props: FilePickerProps) => {
  const {
    id,
    label,
    acceptedFileTypes,
    required,
    disabled,
    inputRef,
    isLoading,
    name,
    cta,
    buttonBgColor,
    ...inputProps
  } = props

  const ctaClickHandler = () => {
    if (!inputRef?.current) {
      return
    }

    inputRef.current.value = ''
    inputRef.current.click()
  }

  const defaultCta = (
    <Button
      onClick={ctaClickHandler}
      id={`${name}-cta`}
      buttonAppearance="text-border"
      color="inherit"
      size="sm"
      loading={isLoading}
      loadingText="Uploading..."
      bgColor={buttonBgColor}
    >
      <BiUpload /> {label}
    </Button>
  )

  return (
    <>
      <Input {...inputProps} id={id} type="file" accept={acceptedFileTypes} size="sm" ref={inputRef} display="none" />
      {cta ? React.cloneElement(cta, { onClick: ctaClickHandler }) : defaultCta}
    </>
  )
}

export default FilePicker
